import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SourceIcon(props: IconProps) {
    return <Icon {...props} iconKey={"source"}/>
}
